/**
 * The agent color palette. Keys match the server's AGENT_COLORS (and the
 * chat_agent.color CHECK); the values are how each draws here. Mid-saturation
 * hues, so each holds up on light and dark backgrounds.
 */
export const AGENT_PALETTE: Record<string, string> = {
  purple: "#7b1fa2",
  teal: "#00838f",
  pink: "#c2185b",
  green: "#2e7d32",
  orange: "#ef6c00",
  blue: "#1565c0",
};

const AUTOMATIC = Object.values(AGENT_PALETTE);

/**
 * An agent's accent: its avatar and the thin rule beside its reply.
 *
 * The color its author picked when there is one; otherwise hashed from the
 * name, so an agent nobody colored still reads the same across turns and
 * reloads. An unknown key (a color added server-side before this client
 * knows it) falls back to the hash rather than drawing nothing.
 */
export function speakerTint(key: string, color?: string | null): { accent: string } {
  if (color && AGENT_PALETTE[color]) return { accent: AGENT_PALETTE[color] };
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) | 0;
  return { accent: AUTOMATIC[Math.abs(hash) % AUTOMATIC.length] };
}
